<!-- Додатковий пінг тестувальників по тікету -->

<template>
    
    <dialogBox >
        <template v-slot:title>{{ $t('PleaseProtest') }} 🥹</template>
        <template v-slot:body>
            <div class="mt-1 text-left">

                <h4 class="fs-15">{{ $t('priority') }}</h4>
                <div class="d-flex gap-3" :class="showError ? 'mb-1' : 'mb-3'">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="priority" id="priority" value="release" v-model="priority">
                        <label class="form-check-label" for="priority">{{ $t('releaseTicket') }}</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="priority" id="preReleaseType" value="preRelease" v-model="priority">
                        <label class="form-check-label" for="preReleaseType">{{ $t('preReleaseTicket') }}</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="priority" id="testType" value="test" v-model="priority">
                        <label class="form-check-label" for="testType">{{ $t('testTicket') }}</label>
                    </div>
                </div>
                <div v-if="showError" class="mb-3">
                    <small class="text-danger">{{ $t('selectPriority') }}</small>
                </div>

                <h4 class="fs-15">{{ $t('Comment') }}</h4>
                <span class="mb-3 text-muted fs-12">{{ $t('testingBox_alert') }}</span>
                <textarea class="form-control mt-3" rows="3" v-model="commentHelp" :placeholder="$t('Comment')"></textarea>
            </div>
        </template>
        <template v-slot:footer-bottom>
            <div class="hstack gap-2 mt-3 justify-content-center remove">
                <button class="btn btn-danger" @click="$emit('close')">{{ $t('cancel') }}</button>
                <button class="btn btn-success" @click="sendTg">{{ $t('Send') }}</button>
            </div>
        </template>
    </dialogBox>

</template>


<script>
import dialogBox from '@/components/modal/dialog'
// import { sendTestingTicketTelegram } from '@/usabilityScripts/logsTelegram.js'
import { nameWorker, tgAccWorker } from '@/usabilityScripts/getNameWorker'
import { storeS } from '@/store'
import { try_AddTicketForTesting } from '../../../../api/services/tickets'

export default ({
    props: ['objCard'],
    components: {
        dialogBox
    },
    data() {
        return {
            commentHelp: '',
            priority: '',
            showError: false
        }
    },
    created(){
        console.log("objCard", this.objCard);
        
    },
    methods: {
        // sendTg(){
        //     // Надсилаємо оповіщення в тг   
            
        //     var ticketdId = this.objCard.ticketId;
        //     var createWorkerId = this.nameWorker(this.user.userid);
        //     var tgAccCreateWorker = this.tgWorker(this.user.userid).tgNick;
        //     var ticketName = this.objCard.ticketName;
        //     var createComment = this.commentHelp

        //     // Викликаємо функцію для відправки повідомлення в телеграм
        //     sendTestingTicketTelegram(ticketName, ticketdId, createWorkerId, tgAccCreateWorker, createComment)
        //     .then(response => {
        //         console.log('Telegram API response:', response.data)
        //         this.$toast.success(this.$t('msgSent'))
        //         this.$emit('close')
        //     })
        //     .catch(error => console.error('Telegram API error:', error)); 
            
        //     // const result = await try_AddTicketForTesting(0, {comment: 'test'});
        // },
        async sendTg(){
            if (!this.priority) {
                this.showError = true;
                return;
            }
            this.showError = false;
            // Надсилаємо оповіщення в тг через бек
            await try_AddTicketForTesting(
                this.objCard.ticketId, 
                {comment: this.commentHelp, priority: this.priority}
            ).then(response => {
                console.log('Telegram API response:', response.data)
                this.$toast.success(this.$t('success'))
                this.$emit('close')
            }).catch(error => {
                console.error('Telegram API error:', error);
                this.$toast.error(this.$t('failure') + " " + error);
            });
            
        },
        nameWorker(item){
            // мутейт імені співробітника
            return nameWorker(item)
        },
        tgWorker(item) {
            // отримання нікнейму співробітника
            return tgAccWorker(item);
        },
    },
    computed:{
        user(){
            return storeS.userbase
        }
    }
})
</script>
